(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jastro-campaign-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jastro-campaign-slider')) {
    customElements.define('jastro-campaign-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.delay = Number(this.dataset.autoplay) || 5500;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dots.forEach((dot) => dot.addEventListener('click', () => { this.show(Number(dot.dataset.dot)); this.restart(); }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start());
        this.start();
      }
      show(next) {
        if (next === this.index || !this.slides.length) return;
        this.slides[this.index]?.classList.remove('is-active');
        this.slides[this.index]?.setAttribute('aria-hidden', 'true');
        this.dots[this.index]?.classList.remove('is-active');
        this.dots[this.index]?.setAttribute('aria-selected', 'false');
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides[this.index]?.classList.add('is-active');
        this.slides[this.index]?.setAttribute('aria-hidden', 'false');
        this.dots[this.index]?.classList.add('is-active');
        this.dots[this.index]?.setAttribute('aria-selected', 'true');
      }
      start() {
        if (this.reduceMotion || this.slides?.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.delay);
      }
      stop() { window.clearInterval(this.timer); this.timer = null; }
      restart() { this.stop(); this.start(); }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
